import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import useApi from "../../api/useApi";
import {
    GetRoleIdentityByIdRequest,
    type GetRoleIdentityByIdResponse,
    type IReturn,
} from "src/api/Tmd.dtos";

const useRoleIdentityById = (
    id?: number | null,
    configuration?: SWRConfiguration<
        GetRoleIdentityByIdResponse,
        GetRoleIdentityByIdResponse
    > | null,
) => {
    const getRequest = useMemo(() => {
        if (!id) return undefined;
        return (): IReturn<GetRoleIdentityByIdResponse> => new GetRoleIdentityByIdRequest({ id });
    }, [id]);

    return useApi(
        "get",
        getRequest,
        {
            getData: (response?: SWRResponse<GetRoleIdentityByIdResponse>) =>
                response?.data?.roleIdentity,
            getError: (response?: SWRResponse<GetRoleIdentityByIdResponse>) =>
                (response?.error ?? response?.data)?.responseStatus,
            getAdditionalState: () => ({}),
        },
        configuration,
    );
};

export default useRoleIdentityById;
